module.exports = __webpack_public_path__ + "img/19_u.71609275.jpg";